/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Accommodation,
    AccommodationFromJSON,
    AccommodationFromJSONTyped,
    AccommodationToJSON,
    House,
    HouseFromJSON,
    HouseFromJSONTyped,
    HouseToJSON,
} from './';

/**
 * 
 * @export
 * @interface HostReservationAccommodationJoin
 */
export interface HostReservationAccommodationJoin {
    /**
     * 
     * @type {number}
     * @memberof HostReservationAccommodationJoin
     */
    id?: number;
    /**
     * 
     * @type {House}
     * @memberof HostReservationAccommodationJoin
     */
    house?: House;
    /**
     * 
     * @type {Accommodation}
     * @memberof HostReservationAccommodationJoin
     */
    accommodation?: Accommodation;
}

export function HostReservationAccommodationJoinFromJSON(json: any): HostReservationAccommodationJoin {
    return HostReservationAccommodationJoinFromJSONTyped(json, false);
}

export function HostReservationAccommodationJoinFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostReservationAccommodationJoin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'house': !exists(json, 'house') ? undefined : HouseFromJSON(json['house']),
        'accommodation': !exists(json, 'accommodation') ? undefined : AccommodationFromJSON(json['accommodation']),
    };
}

export function HostReservationAccommodationJoinToJSON(value?: HostReservationAccommodationJoin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'house': HouseToJSON(value.house),
        'accommodation': AccommodationToJSON(value.accommodation),
    };
}

